<template>
  <div class="w-full lg:w-1/4 mr-10">
    <h3 class="text-lg hidden lg:block">Categories</h3>
    <div class="space-y-3 lg:space-y-1 mt-4">
      <template v-for="category in knowledgeStore.articleCategories" :key="category.value">
        <div>
          <NuxtLink :to="`/knowledge/c/${category.value}`">
            <div
              @click="knowledgeStore.categorySelected(category.value)"
              class="rounded-xl p-4 lg:p-3 lg:px-5 category-card-shadow hover:cursor-pointer"
              :class="{
                'bg-white lg:bg-[#F8F4FF]': knowledgeStore.isActive(category),
                'bg-white lg:bg-transparent': !knowledgeStore.isActive(category)
              }"
            >
              <h4 class="font-semibold" :class="{
                  'text-primary-pressed': knowledgeStore.isActive(category),
                  'lg:text-grey-dark': !knowledgeStore.isActive(category)
                }"
              >
                {{ category.name }}
              </h4>
              <p class="text-sm text-grey-dark mt-2 mb-2 lg:hidden">
                Give us a call, one of our friendly team members will be able to help.
              </p>
              <NuxtLink
                :to="`/knowledge/c/skip-hire-guides`"
                class="text-sm text-primary-pressed flex items-center lg:hidden"
              >
                <span>See all articles</span>
                <CommonSVGTemplate
                  :path="arrowRight"
                  view-box="0 0 24 24"
                  width="24"
                  height="24"
                />
              </NuxtLink>
            </div>
          </NuxtLink>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
const knowledgeStore = useKnowledgeStore();

const arrowRight = `<path fill-rule="evenodd" clip-rule="evenodd" d="M14.9603 11.1423C15.18 11.362 15.18 11.7181 14.9603 11.9378L9.22541 17.6727C9.00573 17.8923 8.64963 17.8923 8.42996 17.6727L8.16476 17.4075C7.94508 17.1878 7.94508 16.8317 8.16476 16.612L13.2367 11.5401L8.16476 6.46812C7.94508 6.24844 7.94508 5.89234 8.16476 5.67267L8.42996 5.40747C8.64963 5.18779 9.00573 5.18779 9.22541 5.40747L14.9603 11.1423Z" fill="#4A08C8"/>`;
</script>
<style>
.category-card-shadow {
  box-shadow: 0px 14px 60px 0px #0C3F651F;
  @screen lg {
    box-shadow: none;
  }
}
</style>
